import React, { useState, Fragment, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { DynamicFormLayout } from '../../components/DynamicForm';
import WithFormConfig from '../../hocs/WithFormConfig';
import { getMethods, objectToUrlParams } from '../../services/commonServices';
import authenticatedFetcher from '../../services/fetcher';
import { useTranslation } from 'react-i18next';
import Message from '../../components/Message';
import LeavePageBlocker from '../../components/LeavePageBlocker'
import { Button, Card } from 'reactstrap';
import { toastSuccess, toastError } from "../../utils/ToastConfig";
import htmlParse from "html-react-parser";
import LoadingSpinner from "../../components/LoadingSpinner";
import cloneDeep from "lodash/cloneDeep";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import BasicModal from '../../components/BasicModal';


const CustomPlanificationsTreasuryForecast = (props) => {
    const [actions = {}] = useState(getMethods(props.config.actions));
    const [t] = useTranslation('app');
    const [isMounted, setIsMounted] = useState(false);
    const [showErrorMessage, handleErrorMessage] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [refreshCount, setRefreshCount] = useState(0);
    const [urlBody, setUrlBody] = useState();
    const history = useHistory();
    const [alertWhenExit, setAlertWhenExit] = useState(false);
    const { read, write, export: exportMethod } = actions || {};
    const [searchParams, setSearchParams] = useState({});
	const [totalsContracts, setTotalsContracts] = useState([]);
	const [totalsFirstBlock, setTotalsFirstBlock] = useState([0, 0, 0, 0, 0, 0]);
	const [totalsSecondBlock, setTotalsSecondBlock] = useState([0, 0, 0, 0, 0, 0]);
    const [rowsData, setRowsData] = useState({});
	const [canEdit, setCanEdit] = useState(true);
	const [monthLabels, setMonthLabels] = useState([]);
    const [showTable, setShowTable] = useState(false);
	const [isClosed, setIsClosed] = useState(false);
	const [closedData, setClosedData] = useState({});
	const [loadingClose, setLoadingClose] = useState(false);
	const [userProfile, setUserProfile] = useState("");
	const [exportPdfLoading, setExportPdfLoading] = useState(false);
	const [exportExcelLoading, setExportExcelLoading] = useState(false);
	const [modalData, setModalData] = useState(null);
	const CLASS_NAME_ROW_GREEN = 'bg-green-300';
	const CLASS_NAME_ROW_YELLOW = 'bg-yellow-150';
	const MONTH_LABELS = [
		"gen", "feb", "mar", "abr", "mai", "jun", "jul", "ago", "sep", "oct", "nov", "des"
	];
	const CONCEPTS = {
		"prod": {
			"label": "Producció",
			"variables": ["Produccion_Mes","Produccion_Mes2","Produccion_Mes3","Produccion_Mes4","Produccion_Mes5","Produccion_Mes6"],
			"totals": [0, 0, 0, 0, 0, 0],
			"totals_first_block": [0, 0, 0, 0, 0, 0],
			"totals_second_block": [0, 0, 0, 0, 0, 0],
			"cobro": false,
			"pago": false,
			"first_table_block": true
		},
		"cert": {
			"label": "Certificació",
			"variables": ["Certificacion_Mes","Certificacion_Mes2","Certificacion_Mes3","Certificacion_Mes4","Certificacion_Mes5","Certificacion_Mes6"],
			"totals": [0, 0, 0, 0, 0, 0],
			"totals_first_block": [0, 0, 0, 0, 0, 0],
			"totals_second_block": [0, 0, 0, 0, 0, 0],
			"cobro": false,
			"pago": false,
			"first_table_block": true
		},
		"cob5": {
			"label": "<strong>Cobrament 5</strong>",
			"variables": ["Cobro1_Mes","Cobro1_Mes2","Cobro1_Mes3","Cobro1_Mes4","Cobro1_Mes5","Cobro1_Mes6"],
			"totals": [0, 0, 0, 0, 0, 0],
			"totals_first_block": [0, 0, 0, 0, 0, 0],
			"totals_second_block": [0, 0, 0, 0, 0, 0],
			"cobro": true,
			"pago": false,
			"first_table_block": true
		},
		"cob20": {
			"label": "<strong>Cobrament 20</strong>",
			"variables": ["Cobro2_Mes","Cobro2_Mes2","Cobro2_Mes3","Cobro2_Mes4","Cobro2_Mes5","Cobro2_Mes6"],
			"totals": [0, 0, 0, 0, 0, 0],
			"totals_first_block": [0, 0, 0, 0, 0, 0],
			"totals_second_block": [0, 0, 0, 0, 0, 0],
			"cobro": true,
			"pago": false,
			"first_table_block": true
		},
		"cob30": {
			"label": "<strong>Cobrament 30</strong>",
			"variables": ["Cobro3_Mes","Cobro3_Mes2","Cobro3_Mes3","Cobro3_Mes4","Cobro3_Mes5","Cobro3_Mes6"],
			"totals": [0, 0, 0, 0, 0, 0],
			"totals_first_block": [0, 0, 0, 0, 0, 0],
			"totals_second_block": [0, 0, 0, 0, 0, 0],
			"cobro": true,
			"pago": false,
			"first_table_block": true
		},
		"pago5": {
			"label": "<strong>Pagament 5</strong>",
			"variables": ["Pago1_Mes","Pago1_Mes2","Pago1_Mes3","Pago1_Mes4","Pago1_Mes5","Pago1_Mes6"],
			"totals": [0, 0, 0, 0, 0, 0],
			"totals_first_block": [0, 0, 0, 0, 0, 0],
			"totals_second_block": [0, 0, 0, 0, 0, 0],
			"cobro": false,
			"pago": true,
			"first_table_block": false
		},
		"pago20": {
			"label": "<strong>Pagament 20</strong>",
			"variables": ["Pago2_Mes","Pago2_Mes2","Pago2_Mes3","Pago2_Mes4","Pago2_Mes5","Pago2_Mes6"],
			"totals": [0, 0, 0, 0, 0, 0],
			"totals_first_block": [0, 0, 0, 0, 0, 0],
			"totals_second_block": [0, 0, 0, 0, 0, 0],
			"cobro": false,
			"pago": true,
			"first_table_block": false
		},
		"pago30": {
			"label": "<strong>Pagament 30</strong>",
			"variables": ["Pago3_Mes","Pago3_Mes2","Pago3_Mes3","Pago3_Mes4","Pago3_Mes5","Pago3_Mes6"],
			"totals": [0, 0, 0, 0, 0, 0],
			"totals_first_block": [0, 0, 0, 0, 0, 0],
			"totals_second_block": [0, 0, 0, 0, 0, 0],
			"cobro": false,
			"pago": true,
			"first_table_block": false
		}
	};
	const [conceptsData, setConceptsData] = useState(CONCEPTS);
	const [showContractTables, setShowContractTables] = useState(false);


    useEffect(() => {
        if (!isMounted && history.location.search) {
            const urlParams = Object.fromEntries(new URLSearchParams(history.location.search));
            if (urlParams.dosearch) {
                handleSearch(urlParams, false);
            }
            setIsMounted(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history.location.search]);

	const initializeTotalsData = (dataTable) => {
    Object.keys(CONCEPTS).map((key) => {
			CONCEPTS[key].totals_first_block = [0, 0, 0, 0, 0, 0];
			CONCEPTS[key].totals_second_block = [0, 0, 0, 0, 0, 0];
		});

		let contractsTotals = [];
		Object.keys(dataTable).map((key) => {
			contractsTotals.push({
				"totals_first_block": [0, 0, 0, 0, 0, 0],
				"totals_second_block": [0, 0, 0, 0, 0, 0]
			});
		});

		return contractsTotals;
  };

	const initializeMonthsLabels = (year, period) => {
		year = parseInt(year.toString().slice(-2));
		period = parseInt(period);
        let newMonthsLabels = [];
		let index = period;
		if( index < 0 ) {
			index = 11;
			year -= 1;
		}
		for( let i = 0; i < 6; ++i ) {
			if( index > 11 ) {
				index = 0;
				year += 1;
			}
			newMonthsLabels.push(MONTH_LABELS[index]+'-'+year);
			index += 1;
		}
		setMonthLabels(newMonthsLabels);
		setRefreshCount((prev) => prev + 1);
		return true;
    };

    const calculateTotals = (items) => {
		let dataTable = items ? items : rowsData;
		let totals_first_block = [0, 0, 0, 0, 0, 0];
		let totals_second_block = [0, 0, 0, 0, 0, 0];
		if (dataTable && Object.keys(dataTable).length > 0) {
			let contractsTotals = initializeTotalsData(dataTable);

			Object.keys(dataTable).map((key) => {
				let count = 0;
				Object.keys(CONCEPTS).map((keyConcept) => {
					Object.keys(CONCEPTS[keyConcept].variables).map((keyVariable) => {
						let variableName = CONCEPTS[keyConcept].variables[keyVariable];
						let variableValue = Number(dataTable[key][variableName]);
						//console.log(variableName + ' ==> ' + dataTable[key][variableName]);
						CONCEPTS[keyConcept].totals[keyVariable] += variableValue;
						if( count > 1 ) {  // nos saltamos los dos primeros conceptos (Producció y Certificació)
							if( CONCEPTS[keyConcept].first_table_block ) {
								CONCEPTS[keyConcept].totals_first_block[keyVariable] += variableValue;
								contractsTotals[key].totals_first_block[keyVariable] += variableValue;
								totals_first_block[keyVariable] += variableValue;
							} else {
								CONCEPTS[keyConcept].totals_second_block[keyVariable] += variableValue;
								contractsTotals[key].totals_second_block[keyVariable] += variableValue;
								totals_second_block[keyVariable] += variableValue;
							}
						}

					});
					count += 1;
				});

			});

			setConceptsData(CONCEPTS);
			setTotalsContracts(contractsTotals);
			setTotalsFirstBlock(totals_first_block);
			setTotalsSecondBlock(totals_second_block);
			setRefreshCount((prev) => prev + 1);
			// console.log(CONCEPTS);

			return true;
		}

		return null;
	};

    const handleSearch = (data, saveParams = true) => {
		if (!read) return;
		const body = Object.entries(data).reduce((acc, [key, value]) => {
			if (typeof value === 'boolean' || value) return { ...acc, [key]: value };
			return acc;
		}, {});
		setSearchParams(body);
		setUrlBody(body);
		const searchParams = objectToUrlParams(body);
		if (saveParams)
			history.push({ search: searchParams });
		//console.log(body);
		setShowTable(false);
		setShowContractTables(body && 'department' in body);

		// GET GENERIC DATA
		authenticatedFetcher({
			method: "POST",
			path: "/planners/treasury-forecast/search/",
			body
		})
			.then((res) => {
				setRowsData([]);
				setCanEdit(true);
				setIsClosed(false);
				setClosedData({});
				setUserProfile("");
				if ('error' in res) {
					setShowTable(false);
					setErrorMessage(res['error']);
					return handleErrorMessage(true);
				}
				initializeMonthsLabels(body['year'], body['period']);
				setRowsData(res['items']);
				setCanEdit(res['can_edit']);
				setUserProfile(res["user_profile"]);
				setIsClosed(res["closed_data"]['Cerrado']);
				setClosedData(res["closed_data"]);
				calculateTotals(res['items']);
				setRefreshCount((prev) => prev + 1);
				handleErrorMessage(false);
				setShowTable(true);
			})
			.catch(() => {
				setShowTable(false);
				handleErrorMessage(true);
			});
	};

	const handleExport = (parameters, is_excel) => {
		if( is_excel ) {
			setExportExcelLoading(true);
		} else {
			setExportPdfLoading(true);
		}

		authenticatedFetcher({
			method: "POST",
			path: "/planners/treasury-forecast/export/",
			body:  { ...parameters, ['excel']: is_excel ? 1 : 0 }
		}).then((res) => {
			if( is_excel ) {
				setExportExcelLoading(false);
			} else {
				setExportPdfLoading(false);
			}

			if ('error' in res) {
				toastError(
					htmlParse(res.error),
					{ autoClose: 'fixed_message' in res ? !res.fixed_message : true }
				);
			} else {
				toastSuccess(
					res.response,
					{ autoClose: 'fixed_message' in res ? !res.fixed_message : true },
					true
				);
			}
			handleErrorMessage(false);
		}).catch(() => handleErrorMessage(true));
	};

	const submitData = () => {
		if (!write) return;
        authenticatedFetcher({
            method: "POST",
            path: "/planners/treasury-forecast/save-data/",
            body: rowsData
        })
            .then((res) => {
                if ('error' in res) {
                    toastError(
                        htmlParse(res.error),
                        { autoClose: false }
                    );
                } else {
                    toastSuccess(
                        res.response,
                        { autoClose: 'fixed_message' in res ? !res.fixed_message : true },
                        true
                    );
                }

                setAlertWhenExit(false);
                handleErrorMessage(false);
                handleSearch(searchParams);
            })
            .catch(() => handleErrorMessage(true));
	};

	const handleCloseOpenTreasuryContracts = (data) => {
		if (!write) return;
		const body = Object.entries(data).reduce((acc, [key, value]) => {
			if (typeof value === 'boolean' || value) return { ...acc, [key]: value };
			return acc;
		}, {});
		setLoadingClose(true);
		authenticatedFetcher({
			method: "POST",
			path: "/planners/treasury-forecast/close-open-treasury-contracts/",
			body
		})
			.then((res) => {
				setLoadingClose(false);
				if ('error' in res) {
					toastError(
						htmlParse(res.error),
						{ autoClose: false }
					);
				} else {
					toastSuccess(
						res.response,
						{ autoClose: true },
						true
					);
					handleSearch(searchParams);
				}
			})
			.catch(() => {
				handleErrorMessage(true);
				setLoadingClose(false);
			});
	};

	const convertToDecimal = (value) => {
		return value === '' ? parseFloat("0.00") : parseFloat(value);
	};

    const parseDecimal = (value, suffix = "", numDecimals = 2) => {
		let default_value = "0,00";
		let parsed_value = (value ? Intl.NumberFormat(
			"es-ES",
			{ maximumFractionDigits: numDecimals, minimumFractionDigits: numDecimals, useGrouping: true }
		).format(value) + suffix : default_value);

		if( parsed_value === "-0,00" ) {
			parsed_value = default_value;
		}
		return parsed_value;
	};

	const updateData = (index, event, recalculate) => {
		let fieldName = event.target.name;
		let fieldValue = event.target.value;
		rowsData[index][fieldName] = fieldValue;
		setAlertWhenExit(true);
		setRowsData(rowsData);
		if( recalculate) {
			calculateTotals(rowsData);
		}
		setRefreshCount((prev) => prev + 1);
	};

	const renderTableTotalsHeader = () => {
		return (
			<Fragment>
				<thead>
					<tr>
						<td className="text-center td-blue-white"  width="52%" colSpan="5">
							<strong>TOTALS PREVISTOS</strong>
						</td>
						{monthLabels && Object.keys(monthLabels).map((key) => {
							return (
								<Fragment>
									<td className="text-center td-green-header" width="8%">
										{monthLabels[key]}
									</td>
								</Fragment>
							);
						})}
					</tr>
				</thead>
			</Fragment>
		);
	};

	const renderTableContractsHeader = () => {
		return (
			<Fragment>
				<thead>
					<tr>
						<td className="text-center td-green-header"  width="5%">
							Nº SIE
						</td>
						<td className="text-center td-green-header" width="17%">
							NOM
						</td>
						<td className="text-center td-green-header" width="5%">
							PAGA DIES
						</td>
						<td className="text-center td-green-header" width="15%">
							CLIENT
						</td>
						<td className="text-center td-green-header" width="10%"></td>
						{monthLabels && Object.keys(monthLabels).map((key) => {
							return (
								<Fragment>
									<td className="text-center td-green-header" width="8%">
										{monthLabels[key]}
									</td>
								</Fragment>
							);
						})}
					</tr>
				</thead>
			</Fragment>
		);
	};

	const renderTableTotalsRows = (first_table_block = true) => {
		return (
			<Fragment>
				<tbody>
					{conceptsData && Object.keys(conceptsData).map((key) => {
						if( conceptsData[key]["first_table_block"] !== first_table_block ) {
							return null;
						}
						return (
							<Fragment>
								<tr>
									<td className="text-center bg-white" width="5%"></td>
									<td className="text-center bg-white" width="17%"></td>
									<td className="text-center bg-white" width="5%"></td>
									<td className="text-center bg-white" width="15%"></td>
									<td className="text-center bg-white" width="10%">
										{htmlParse(conceptsData[key]["label"])}
									</td>
									<td className="text-center td-bg-blue-white" width="8%">
										<span>{parseDecimal(conceptsData[key]["totals"][0])}</span>
									</td>
									<td className="text-center td-bg-blue-white" width="8%">
										<span>{parseDecimal(conceptsData[key]["totals"][1])}</span>
									</td>
									<td className="text-center td-bg-blue-white" width="8%">
										<span>{parseDecimal(conceptsData[key]["totals"][2])}</span>
									</td>
									<td className="text-center td-bg-blue-white" width="8%">
										<span>{parseDecimal(conceptsData[key]["totals"][3])}</span>
									</td>
									<td className="text-center td-bg-blue-white" width="8%">
										<span>{parseDecimal(conceptsData[key]["totals"][4])}</span>
									</td>
									<td className="text-center td-bg-blue-white" width="8%">
										<span>{parseDecimal(conceptsData[key]["totals"][5])}</span>
									</td>
								</tr>
							</Fragment>
						);
					})}

				</tbody>
			</Fragment>
		);
	};

	const renderTableContractsRowTotals = (index, first_table_block = true, label = 'TOTAL PAGAMENTS') => {
		let totalsContract = totalsContracts[index][first_table_block ? 'totals_first_block' : 'totals_second_block'];
		return (
			<Fragment>
				<tr>
					<td className="text-center" width="5%"></td>
					<td className="text-center"  width="17%"></td>
					<td className="text-center" width="5%"></td>
					<td className="text-center" width="15%"></td>
					<td className="text-center td-blue_gray" width="10%">
						{label}
					</td>

					<td className="text-center td-blue_gray" width="8%">
						<span>{parseDecimal(totalsContract[0])}</span>
					</td>
					<td className="text-center td-blue_gray" width="8%">
						<span>{parseDecimal(totalsContract[1])}</span>
					</td>
					<td className="text-center td-blue_gray" width="8%">
						<span>{parseDecimal(totalsContract[2])}</span>
					</td>
					<td className="text-center td-blue_gray" width="8%">
						<span>{parseDecimal(totalsContract[3])}</span>
					</td>
					<td className="text-center td-blue_gray" width="8%">
						<span>{parseDecimal(totalsContract[4])}</span>
					</td>
					<td className="text-center td-blue_gray" width="8%">
						<span>{parseDecimal(totalsContract[5])}</span>
					</td>
				</tr>
			</Fragment>
		);
	};

	const renderTableContractsRows = (index, item, first_table_block=true) => {
		let count = 0;
		let isEditable = !item.Cerrado;
		return (
			<Fragment>
					{conceptsData && Object.keys(conceptsData).map((key) => {
						if( conceptsData[key]["first_table_block"] !== first_table_block ) {
							return null;
						}
						count += 1;
						
						return (
							<Fragment>
								<tr>
									<td className="text-center bg-white" width="5%">
										{first_table_block && count === 1 && (
											<strong>{item?.Contrato}</strong>
										)}
									</td>
									<td className="text-left bg-white"  width="17%">
										{first_table_block && count === 1 && (
											<strong>{item?.Contrato_nombre}</strong>
										)}
									</td>
									<td className="text-center bg-white" width="5%">
										{first_table_block && count === 1 && (
											<span className="text-left bg-white">
												{item?.Pago_Dias}
											</span>
										)}
									</td>
									<td className="text-left bg-white" width="15%">
										{first_table_block && count === 1 && (
											<span className="text-left bg-white">
												{item?.Cliente}
											</span>
										)}
									</td>
									<td className="text-center bg-white" width="10%">
										{htmlParse(conceptsData[key]["label"])}
									</td>

									<td className={count < 3 ? 'text-center '+CLASS_NAME_ROW_GREEN : 'text-center '+CLASS_NAME_ROW_YELLOW} width="8%">
										{isEditable ? (
											<input
												className="form-control input-text-wrapper input-planning-small text-center"
												type="number"
												name={conceptsData[key]["variables"][0]}
												defaultValue={eval('item?.'+conceptsData[key]["variables"][0])}
												onChange={event => updateData(index, event, true)}
											/>
										) : (
											<span className="status-from-buttons-in-table-item-list">
												{parseDecimal(eval('item?.'+conceptsData[key]["variables"][0]))}
											</span>
										)}
									</td>
									<td className={count < 3 ? 'text-center '+CLASS_NAME_ROW_GREEN : 'text-center '+CLASS_NAME_ROW_YELLOW} width="8%">
										{isEditable ? (
											<input
												className="form-control input-text-wrapper input-planning-small text-center"
												type="number"
												name={conceptsData[key]["variables"][1]}
												defaultValue={eval('item?.'+conceptsData[key]["variables"][1])}
												onChange={event => updateData(index, event, true)}
											/>
										) : (
											<span className="status-from-buttons-in-table-item-list">
												{parseDecimal(eval('item?.'+conceptsData[key]["variables"][1]))}
											</span>
										)}
									</td>
									<td className={count < 3 ? 'text-center '+CLASS_NAME_ROW_GREEN : 'text-center '+CLASS_NAME_ROW_YELLOW} width="8%">
										{isEditable ? (
											<input
												className="form-control input-text-wrapper input-planning-small text-center"
												type="number"
												name={conceptsData[key]["variables"][2]}
												defaultValue={eval('item?.'+conceptsData[key]["variables"][2])}
												onChange={event => updateData(index, event, true)}
											/>
										) : (
											<span className="status-from-buttons-in-table-item-list">
												{parseDecimal(eval('item?.'+conceptsData[key]["variables"][2]))}
											</span>
										)}
									</td>
									<td className={count < 3 ? 'text-center '+CLASS_NAME_ROW_GREEN : 'text-center '+CLASS_NAME_ROW_YELLOW} width="8%">
										{isEditable ? (
											<input
												className="form-control input-text-wrapper input-planning-small text-center"
												type="number"
												name={conceptsData[key]["variables"][3]}
												defaultValue={eval('item?.'+conceptsData[key]["variables"][3])}
												onChange={event => updateData(index, event, true)}
											/>
										) : (
											<span className="status-from-buttons-in-table-item-list">
												{parseDecimal(eval('item?.'+conceptsData[key]["variables"][3]))}
											</span>
										)}
									</td>
									<td className={count < 3 ? 'text-center '+CLASS_NAME_ROW_GREEN : 'text-center '+CLASS_NAME_ROW_YELLOW} width="8%">
										{isEditable ? (
											<input
												className="form-control input-text-wrapper input-planning-small text-center"
												type="number"
												name={conceptsData[key]["variables"][4]}
												defaultValue={eval('item?.'+conceptsData[key]["variables"][4])}
												onChange={event => updateData(index, event, true)}
											/>
										) : (
											<span className="status-from-buttons-in-table-item-list">
												{parseDecimal(eval('item?.'+conceptsData[key]["variables"][4]))}
											</span>
										)}
									</td>
									<td className={count < 3 ? 'text-center '+CLASS_NAME_ROW_GREEN : 'text-center '+CLASS_NAME_ROW_YELLOW} width="8%">
										{isEditable ? (
											<input
												className="form-control input-text-wrapper input-planning-small text-center"
												type="number"
												name={conceptsData[key]["variables"][5]}
												defaultValue={eval('item?.'+conceptsData[key]["variables"][5])}
												onChange={event => updateData(index, event, true)}
											/>
										) : (
											<span className="status-from-buttons-in-table-item-list">
												{parseDecimal(eval('item?.'+conceptsData[key]["variables"][5]))}
											</span>
										)}
									</td>
								</tr>
							</Fragment>
						);
					})}

			</Fragment>
		);
	};

	const renderTableTotalsRowTotals = (first_table_block = true, label = 'TOTAL COBRAMENTS') => {
		let totals = first_table_block ? totalsFirstBlock : totalsSecondBlock;
		return (
			<Fragment>
				<tr>
					<td className="text-center" width="5%"></td>
					<td className="text-center"  width="17%"></td>
					<td className="text-center" width="5%"></td>
					<td className="text-center" width="15%"></td>
					<td className="text-center td-blue_gray" width="10%">
						{label}
					</td>

					<td className="text-center td-blue_gray" width="8%">
						<span>{parseDecimal(totals[0])}</span>
					</td>
					<td className="text-center td-blue_gray" width="8%">
						<span>{parseDecimal(totals[1])}</span>
					</td>
					<td className="text-center td-blue_gray" width="8%">
						<span>{parseDecimal(totals[2])}</span>
					</td>
					<td className="text-center td-blue_gray" width="8%">
						<span>{parseDecimal(totals[3])}</span>
					</td>
					<td className="text-center td-blue_gray" width="8%">
						<span>{parseDecimal(totals[4])}</span>
					</td>
					<td className="text-center td-blue_gray" width="8%">
						<span>{parseDecimal(totals[5])}</span>
					</td>
				</tr>
			</Fragment>
		);
	};

  const renderTableTotals = () => {
		let showClosedButton = !showContractTables && rowsData && !canEdit;
		let classCardTable = rowsData ? 'mt-1' : 'mt-4';
		return (
			<Fragment>
				{rowsData && (
					<Fragment>
						<div className="row mt-4" style={{marginBottom: "20px"}}>
							<div className="col-xl-6 col-md-6 col-sm-6 col-12">
								{(rowsData) && (
									<Fragment>
										{!isClosed ? (
											<Fragment>
												{(searchParams 
													&& (!('delegation' in searchParams) || ('delegation' in searchParams && searchParams['delegation'] !== '06' && searchParams['delegation'] !== '07')) 
													&& !('contract' in searchParams) 
													&& ('department' in searchParams || userProfile === "superadmin")) 
													&& (
													<Button size="submitButton btn btn-secondary btn-planning"
														className="btn-small btn-green"
														onClick={handleCloseForecast('close')}>
														<LoadingSpinner show={loadingClose} /> {t('TANCAR PREVISIÓ')}
													</Button>
												)}
											</Fragment>
										) : (
											<Fragment>
												<Button size="submitButton btn btn-secondary btn-planning" className="btn-small btn-red">
													{t('PREVISIÓ TANCADA')}
												</Button>

												{(closedData && searchParams && ('department' in searchParams)) && (
													<span className="legend-text" style={{paddingLeft: "10px"}}>
														Validat per {closedData['Cerrado_usuario']} el {closedData['Cerrado_fecha']} h.
													</span>
												)}
												{(userProfile === "superadmin" && searchParams && !('contract' in searchParams)) && (
													<Button size="submitButton btn btn-secondary btn-planning"
														className="btn-small btn-orange"
														onClick={handleCloseForecast('open')}
														style={{marginLeft: "10px"}}
													>
														<LoadingSpinner show={loadingClose} /> {t('REOBRIR PREVISIÓ')}
													</Button>
												)}
											</Fragment>
										)}
									</Fragment>
								)}
							</div>
							<div className="col-xl-6 col-md-6 col-sm-6 col-12" style={{textAlign: "right"}}>
								<Button size="btn btn-secondary btn-sm"
										style={{backgroundColor: "rgb(244, 164, 96)", width: "220px"}}
										onClick={() => handleExport(searchParams, false)}
								>
									<LoadingSpinner show={exportPdfLoading} />
									<FontAwesomeIcon
									  icon={['fas', 'file-pdf']}
									  className="svg-inline--fa fa-file-excel fa-w-12 text-light"
									/>
									<span className="btn-wrapper--label text-light">
										{t('Exportar PDF')}
									</span>
								</Button>
								<Button size="btn btn-secondary btn-sm"
										style={{backgroundColor: "rgb(102, 205, 170)", width: "220px"}}
										onClick={() => handleExport(searchParams, true)}
								>
									<LoadingSpinner show={exportExcelLoading} />
									<FontAwesomeIcon
									  icon={['fas', 'file-excel']}
									  className="svg-inline--fa fa-file-excel fa-w-12 text-light"
									/>
									<span className="btn-wrapper--label text-light">
										{t('Exportar Excel')}
									</span>
								</Button>
							</div>
						</div>
					</Fragment>
				)}
				<div className={`card-box listado-personas card planification-module ${classCardTable} mb-3`}>
					<div className="table-responsive">
						<table className="mb-0 table table-hover table-bordered">
							{renderTableTotalsHeader()}
							{renderTableTotalsRows(true)}
							{renderTableTotalsRowTotals(true, 'TOTAL COBRAMENTS')}
							{renderTableTotalsRows(false)}
							{renderTableTotalsRowTotals(false, 'TOTAL PAGAMENTS')}
					   </table>
					</div>
				</div>
			</Fragment>
		);
	};

	const renderTableContract = (index, item) => {
		return (
			<Fragment>
				<div className="card-box listado-personas card planification-module mt-3">
					<div className="table-responsive" style={{border: "3px solid LightSteelBlue"}}>
						<table className="mb-0 table table-hover table-bordered">
							{index === 0 && renderTableContractsHeader()}
							<tbody>
								{renderTableContractsRows(index, item, true)}
								{renderTableContractsRowTotals(index, true, 'TOTAL COBRAMENTS')}
								{renderTableContractsRows(index, item, false)}
								{renderTableContractsRowTotals(index, false, 'TOTAL PAGAMENTS')}
							</tbody>
					   	</table>
					</div>
				</div>
			</Fragment>
		);
	};

	const CloseOpenTreasuryContracts = (open_treasury) => {
		if( rowsData.length > 0 ) {
			let dataToSend = cloneDeep(searchParams);
			dataToSend["open"] = open_treasury;
			dataToSend["contract_codes"] = [];
			for( let index = 0; index < rowsData.length; index++ ) {
				dataToSend["contract_codes"].push(rowsData[index]["Contrato"])
			}
			handleCloseOpenTreasuryContracts(dataToSend);
		}
	};

	const handleCloseForecast = (variant = 'close' || 'open' ) => () => {
		const modalData = {
			description: '',
			icon: 'faExclamationTriangle',
			func: CloseOpenTreasuryContracts,
			func_value: 0
		};
		switch(variant){
			case 'close':
				modalData['func_value'] = 0;
				modalData['description'] = 'Segur que desitja tancar la previsió?';
				modalData['confirmBtn'] = 'Acceptar';
				break;
			case 'open':
				modalData['func_value'] = 1;
				modalData['description'] = 'Segur que desitja reobrir la previsió?';
				modalData['confirmBtn'] = 'Acceptar';
				break;
		}
		setModalData(modalData);
	}
	const closeModal = () => {
		setModalData(null);
	}
	const confirmModal = () => {
		modalData.func(modalData.func_value);
		closeModal();
	}

	const renderTableContracts = () => {
		return (
			<Fragment>
				{showContractTables && canEdit && (
					<Fragment>
						<div style={{ textAlign: "right",  marginTop: "1rem" }}>
							<Button size="submitButton btn btn-secondary btn-planning"
								style={{ "border": "1px solid", width: "150px" }}
								onClick={() => submitData()}>
								{t('DESAR')}
							</Button>
						</div>
					</Fragment>
				)}
				{showContractTables && rowsData && Object.keys(rowsData).map((index) => {
					return renderTableContract(parseInt(index), rowsData[index]);
				})}
				{showContractTables && canEdit && (
					<Fragment>
						<div style={{ "float": "right", textAlign: "right", "width": "51%", marginTop: "1rem" }}>
							<Button size="submitButton btn btn-secondary btn-planning"
								style={{ "border": "1px solid", width: "150px" }}
								onClick={() => submitData()}>
								{t('DESAR')}
							</Button>
						</div>
					</Fragment>
				)}
			</Fragment>
		);
	};

    return (
		<Fragment>
            <LeavePageBlocker when={alertWhenExit} />
			<div className="planification-module">
				<DynamicFormLayout
					config={props.config}
					onSubmit={handleSearch}
					withoutButtonsBar
					withoutRelateds
					filterMode
					isSearcher
					tabProcessingOptions={{
						loadDefaultData: true,
					}}
					inputsAlign={
						{
							labelColumn: { sm: 6, md: 5, lg: 4 },
							inputColumn: { sm: 6, md: 7, lg: 8 }
						}
					}
				/>

				{showTable && !showErrorMessage ? (
					<Fragment>
						{renderTableTotals()}
						{renderTableContracts()}
					</Fragment>

				) : (
					showErrorMessage && (
						<Card className="mt-4 p-2">
							<Message type="error" className="m-0">
								{errorMessage}
							</Message>
						</Card>
					)
				)}
			</div>
			<BasicModal
				title={modalData?.description}
				onCancel={closeModal}
				onConfirm={confirmModal}
				isOpen={!!modalData}
				confirmText={modalData?.confirmBtn}
				icon={modalData?.icon}
				toggle={closeModal}/>
		</Fragment>
	);



};

CustomPlanificationsTreasuryForecast.propTypes = {};

export default WithFormConfig(
    CustomPlanificationsTreasuryForecast,
    true,
    'planifications-treasury-forecast-searcher',
    { urlParametersFirst: true }
);
